import { dataset, projectId } from "@/sanity/env"
import type { SanityImageSource } from "@sanity/image-url"
import { createImageUrlBuilder } from "@sanity/image-url"

const builder = createImageUrlBuilder({
    projectId: projectId || "",
    dataset: dataset || ""
})

export function buildImageUrl(source: SanityImageSource) {
    return builder.image(source)
}
